import { render } from "./HochschuleDetailsStandorteModalCreate.pug?vue&type=template&id=58b2f63a&lang=pug"
import script from "./HochschuleDetailsStandorteModalCreate.js?vue&type=script&lang=js"
export * from "./HochschuleDetailsStandorteModalCreate.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__